import React from "react";
import { Box, CircularProgress } from "@mui/material";

import { useDataStore } from "../dataStore";

export default function PublicBootstrapGate({ children }) {
  const { publicImagesReady, publicPresentationReady } = useDataStore();
  const ready = publicPresentationReady && publicImagesReady;

  if (ready) return children;

  return (
    <Box
      role="status"
      aria-label="Loading website"
      aria-live="polite"
      aria-busy="true"
      sx={{
        position: "fixed",
        inset: 0,
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        bgcolor: "#f7f7f5",
        color: "#5f6368",
      }}
    >
      <CircularProgress aria-hidden="true" size={30} color="inherit" />
    </Box>
  );
}
